import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ChartOptions, ChartData } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';
@Component({
	selector: 'portals-line',
	templateUrl: './line.component.html',
	styleUrls: ['./line.component.scss'],
})
export class LineComponent implements OnInit {
	@ViewChild(BaseChartDirective) chart: BaseChartDirective | undefined;
	@Input() lineChartData: ChartData<'line'> = {
		datasets: [],
	};
	@Input() lineChartLabels: string[] | any[] | undefined = [];
	@Input() lineChartOptions: ChartOptions<'line'> = {
		responsive: true,
	};
	@Input() lineChartLegend = true;
	@Input() lineChartPlugins = [];

	lineChartType: 'line' = 'line'; // Set the type as a string

	constructor() {}
	ngOnChanges(): void {
		if (this.chart) {
			this.chart.update();
		}
	}
	ngOnInit(): void {}
}
